import { styled } from '@zenbusiness/zui/styles';

export const PayeeWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'usedAtDashboard' && prop !== 'isLatest'
})(({ usedAtDashboard, isLatest, theme }) => ({
  width: '100%',
  height: 'auto',
  padding: `${usedAtDashboard ? '18px 0' : '24px 0'}`,
  display: 'flex',
  borderBottom: `${isLatest && usedAtDashboard ? 'none' : '1px solid'}`,
  borderColor: theme.palette.border.main,
  justifyContent: 'space-between',
  alignItems: 'center'
}));
